<template>
    <div>
        <span v-for="(link, key) in links" :key="key">
            <!-- Previous Button -->
            <span
                v-if="link.label.toLowerCase().includes('previous')"
                class="
                    border border-gray-400
                    rounded-tl-3xl rounded-bl-3xl
                    px-3
                    py-2
                    text-sm
                "
            >
                <inertia-link
                    v-if="link.url"
                    :href="link.url"
                    class="text-secondary hover:text-primary"
                >
                    <i class="icon-np-chevron-left"></i>
                </inertia-link>
                <i v-else class="icon-np-chevron-left text-gray-400"></i>
            </span>

            <!-- Next Button -->
            <span
                v-else-if="link.label.toLowerCase().includes('next')"
                class="
                    border border-gray-400
                    rounded-tr-3xl rounded-br-3xl
                    px-3
                    py-2
                    text-sm
                "
            >
                <inertia-link
                    v-if="link.url"
                    :href="link.url"
                    class="text-secondary hover:text-primary"
                >
                    <i class="icon-np-chevron-right"></i>
                </inertia-link>
                <i v-else class="icon-np-chevron-right text-gray-400"></i>
            </span>

            <span
                v-else
                class="
                    border-t border-b border-gray-400
                    px-3
                    py-2
                    text-sm
                    hover:text-primary
                "
                :class="{
                    'text-primary': link.active,
                    'font-medium': link.active,
                    'text-secondary': !link.active,
                }"
            >
                <inertia-link v-if="link.url" :href="link.url">
                    <span>{{ link.label }}</span>
                </inertia-link>
                <span v-else>{{ link.label }}</span>
            </span>
        </span>
    </div>
</template>

<script>
export default {
    props: {
        links: {
            type: Array,
            required: true,
        },
    },
};
</script>
